import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ReceptionApiAdapter } from '../adapters/ReceptionApiAdapter';
import { Package, SplitPackageRequest } from '../models/Reception';
import { ReceptionService } from '../services/ReceptionService';

interface SplitPackageParams {
  receptionId: number;
  pkg: Package;
  receptionStatus: string;
  data: SplitPackageRequest;
}

/**
 * Hook para dividir un paquete
 */
export const useSplitPackage = () => {
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new ReceptionApiAdapter(httpClient);
  const receptionService = new ReceptionService(apiAdapter);

  return useMutation({
    mutationFn: ({ receptionId, pkg, receptionStatus, data }: SplitPackageParams) =>
      receptionService.splitPackage(receptionId, pkg, receptionStatus, data),
    onSuccess: (updatedReception) => {
      // Invalidar queries de lista
      queryClient.invalidateQueries({ queryKey: ['receptions'] });
      queryClient.invalidateQueries({ queryKey: ['receptions-simple'] });
      // Actualizar el cache del detalle con la respuesta
      queryClient.setQueryData(['reception', updatedReception.id], updatedReception);
    },
  });
};

